<template>
  <form
    method="post"
    @submit.prevent="submit"
  >
    <div class="mb-3">
      <v-text-input
        id="profile-first-name"
        label="word.first_name"
        v-model="data.first_name"
        :errors="errors.first_name"
      />
    </div>

    <div class="row">
      <div class="col-lg-4 mb-3">
        <v-text-input
          id="profile-infix"
          label="word.infix"
          v-model="data.infix"
          :errors="errors.infix"
        />
      </div>
      <div class="col-lg-8 mb-3">
        <v-text-input
          id="profile-last-name"
          label="word.last_name"
          v-model="data.last_name"
          :errors="errors.last_name"
        />
      </div>
    </div>
    <hr/>
    <div class="mb-3">
      <v-text-input
        id="profile-zip"
        label="word.zip"
        help-text="phrase.zip_four_digits"
        v-model="data.zip"
        :errors="errors.zip"
        :max-length="4"
        :required="true"
      />
    </div>
    <div class="mb-3">
      <v-radio-buttons
        id="profile-gender"
        label="word.gender"
        :choices="GENDER_CHOICES"
        v-model="data.gender"
        :errors="errors.gender"
        :horizontal="true"
        :required="true"
      />
    </div>
    <div class="mb-5">
      <v-date-input
        v-model="data.birth_date"
        :errors="errors.birth_date"
        label="word.birth_date"
        id="profile-birth-date"
        :max-date="new Date()"
        :min-date="new Date(1900, 1, 1)"
        :required="true"
      />
    </div>
    <div class="d-flex justify-content-end">
      <v-button
        id="profile-submit"
        text="word.save"
        type="submit"
        :loader="loader"
      />
    </div>
  </form>
</template>

<script>
import Button from '@/common/components/Button.vue';
import DateInput from '@/common/components/inputs/DateInput.vue';
import RadioButtons from '@/common/components/inputs/RadioButtons.vue';
import TextInput from '@/common/components/inputs/TextInput.vue';
import { GenericFormMixin } from '@/common/utils/mixins';
import { mapActions, mapGetters } from 'vuex';
import { toFormattedDate } from '@/common/utils/formatting';
import { notify } from '@/common/utils/notify';
import { GENDER_CHOICES } from '@/common/utils/constants';

export default {
  name: 'UserProfileUpdate',
  components: {
    'v-button': Button,
    'v-date-input': DateInput,
    'v-radio-buttons': RadioButtons,
    'v-text-input': TextInput,
  },
  data() {
    return {
      GENDER_CHOICES,
      apiPath: 'users/profile/',
      apiMethod: 'patch',
      data: {
        first_name: null,
        infix: null,
        last_name: null,
        zip: null,
        gender: null,
        birth_date: null,
      },
    };
  },
  computed: {
    ...mapGetters(['user']),
  },
  methods: {
    ...mapActions(['refreshUser']),
    preProcess() {
      const data = this.copyData();
      data.birth_date = toFormattedDate(this.data.birth_date);
      return data;
    },
    postProcess() {
      this.refreshUser();
      notify('phrase.edit_success');
    },
  },
  mixins: [
    GenericFormMixin,
  ],
  created() {
    this.data.username = this.user.username;
    this.data.first_name = this.user.profile.first_name || '';
    this.data.infix = this.user.profile.infix || '';
    this.data.last_name = this.user.profile.last_name || '';

    if (this.user.profile.zip) {
      this.data.zip = this.user.profile.zip.replace(/[^0-9]+/g, '');
    } else {
      this.data.zip = '';
    }

    this.data.gender = this.user.profile.gender || '';
    if (this.user.profile.birth_date) {
      this.data.birth_date = new Date(this.user.profile.birth_date);
    }
  },
};
</script>
